import { render, staticRenderFns } from "./AttachmentView.vue?vue&type=template&id=17b135e2&"
import script from "./AttachmentView.vue?vue&type=script&lang=js&"
export * from "./AttachmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports